import { render, staticRenderFns } from "./gcategory.vue?vue&type=template&id=e77ced9a&scoped=true&"
import script from "./gcategory.vue?vue&type=script&lang=js&"
export * from "./gcategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77ced9a",
  null
  
)

export default component.exports